import React from 'react';
import MaterialInputArea, { MaterialInputAreaProps } from '../../MaterialInputArea';

export type FormInputAreaProps = MaterialInputAreaProps & {};
const FormInputArea = ({ className, rows = 3, disabled = false, ref, ...rest }: FormInputAreaProps) => {
  return <MaterialInputArea {...rest} disabled={disabled} rows={rows} className={className} />;
};

export default FormInputArea;
